import { StyledButton } from "../Button";
import styled from "@emotion/styled";
export const StyledButtonAnchor = styled(StyledButton.withComponent("a"))({
  textDecoration: "none"
});
